module.exports = __webpack_public_path__ + "static/media/logo-yampi.885dd810.svg";